import { lazy } from "react";

// Manifeste du plugin « Suivi d'événements » (voir ../registry.js).
// Volontairement minuscule : le module vitrine (runtime.js) et le tableau de
// bord admin sont chargés à la demande, jamais dans le bundle initial.
const manifest = {
  key: "event-tracking",
  name: "Suivi d'événements",
  load: () => import("./runtime"),
  admin: {
    routes: [
      { path: "regie/evenements", Component: lazy(() => import("./admin/EventTrackingDashboard")) },
    ],
    nav: [
      { parent: "/admin/regie", to: "/admin/regie/evenements", label: "Événements & parcours" },
    ],
  },
};

export default manifest;
